export default __webpack_public_path__ + "static/media/jiffy_envelope.c2fac2bd.png";